import { stringify } from "qs";

export class ReceiptClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/receipts`;
  }

  async getUnsent(params) {
    const querystring = stringify(params, { addQueryPrefix: true });

    const url = `${this.baseURL}/unsent${querystring}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getResend(params) {
    const querystring = stringify(params, { addQueryPrefix: true });

    const url = `${this.baseURL}${querystring}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async previewPdf(url, language) {
    const response = await this.httpClient.request("get", url, {
      headers: { "x-accept-language": language },
      responseType: 'blob',
    });

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async postConfirm(id, data) {
    const url = `${this.baseURL}/${id}/confirm`;

    const response = await this.httpClient.request("post", url, { data });

    return response;
  }

  async postSend(id, language) {
    const url = `${this.baseURL}/${id}/send`;

    const response = await this.httpClient.request("post", url, {
      headers: { "x-accept-language": language }
    });

    return response;
  }

  async postResend(id, language) {
    const url = `${this.baseURL}/${id}/resend`;

    const response = await this.httpClient.request("post", url, {
      headers: { "x-accept-language": language }
    });

    return response;
  }

  async getSellerTradeParties() {
    const url = `${this.baseURL}/seller_trade_parties`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getAllSellerTradeParties() {
    const url = `${this.baseURL}/seller_trade_parties/all`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async postCancelReceipt(params) {
    const url = `${this.baseURL}/cancel`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async postDeleteExampleReceipt(id, params) {
    const url = `${this.baseURL}/${id}/void`

    const response = await this.httpClient.request("post", url, { data: params });

    return response;
  }

  async putOfflinePdf(id, params) {
    const url = `${this.baseURL}/${id}/offline_pdf`

    const response = await this.httpClient.request("put", url, { data: params });

    return response;
  }

  async putWithholdingTaxImageKeys(id, params) {
    const url = `${this.baseURL}/withholding_tax/image/${id}/invoice`

    const response = await this.httpClient.request("put", url, { data: params });

    return response;
  }

  async postBillingAction(id, data) {
    const url = `${this.baseURL}/${id}/action`;

    const response = await this.httpClient.request("post", url, { data });

    return response;
  }

  async updateReceiptInformation(id, params) {
    const url = `${this.baseURL}/${id}/update_receipt_information`

    const response = await this.httpClient.request("put", url, { data: params });

    return response;
  }
}
